import PasswordConfirmModal from "./PasswordConfirm";
import PasswordViolatedModal from "./PasswordViolated";
import ImportDuplicateModal from "./ImportDuplicate";
import EncryptionUpdateModal from "./EncryptionUpdate";

const modalsComponents = {
  PasswordConfirmModal,
  PasswordViolatedModal,
  ImportDuplicateModal,
  EncryptionUpdateModal
}

export default modalsComponents